import { createContext, useContext, useState } from 'react';

interface FontSizeContextType {
  fontScale: number;
  increaseFontSize: () => void;
  decreaseFontSize: () => void;
}

const FontSizeContext = createContext<FontSizeContextType | undefined>(undefined);

export function FontSizeProvider({ children }: { children: React.ReactNode }) {
  const [fontScale, setFontScale] = useState(0);

  const increaseFontSize = () => {
    setFontScale((prev) => Math.min(prev + 1, 1));
  };

  const decreaseFontSize = () => {
    setFontScale((prev) => Math.max(prev - 1, -1));
  };

  return (
    <FontSizeContext.Provider value={{ fontScale, increaseFontSize, decreaseFontSize }}>
      <div style={{ '--font-scale': fontScale } as React.CSSProperties}>{children}</div>
    </FontSizeContext.Provider>
  );
}

export function useFontSize() {
  const context = useContext(FontSizeContext);
  if (!context) {
    throw new Error('useFontSize must be used within a FontSizeProvider');
  }
  return context;
}
